import { DialogTitle, Typography, DialogContent, Dialog, Button } from '@material-ui/core'
import React from 'react'

interface ConfirmFixDuplicatesModalProps {
  open: boolean
  onClose: () => void
  handleFixDuplicateProducts: () => void
}

export const ConfirmFixDuplicatesModal: React.FC<ConfirmFixDuplicatesModalProps> = ({
  open,
  onClose,
  handleFixDuplicateProducts,
}) => {
  const fixDuplicates = async () => {
    try {
      await handleFixDuplicateProducts()
      onClose()
    } catch (error) {
      console.error('Error fixing duplicate products:', error)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography component="h2" style={{ fontSize: '1.25rem', fontWeight: 600 }}>
            Are you sure you want to Automatically Fix Duplicate Product Names?
          </Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={onClose}
          style={{ minWidth: 80, marginRight: 8 }}
        >
          Cancel
        </Button>
        <Button
          size="small"
          variant="contained"
          color="secondary"
          onClick={fixDuplicates}
          style={{ minWidth: 80 }}
        >
          Fix Automatically
        </Button>
      </DialogContent>
    </Dialog>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/MigrateCompanyProducts/ConfirmFixDuplicatesModal.tsx